import {
    type ListingPage,
    listingPageMoneyRangeSchema,
} from "./listing-page.contract.ts";

export type ListingMoneyRange = NonNullable<ListingPage["listing"]["price"]>;

export function buildUsdMoneyRange(
    minAmount: number | null,
    maxAmount: number | null,
): ListingMoneyRange | null {
    let min = minAmount !== null && minAmount > 0 ? minAmount : null;
    let max = maxAmount !== null && maxAmount > 0 ? maxAmount : null;
    if (min === null && max === null) return null;

    if (min !== null && max !== null && min > max) {
        [min, max] = [max, min];
    }

    return listingPageMoneyRangeSchema.parse({
        currency: "USD",
        min,
        max,
    });
}
